@for (incidental of incidentals.controls; track incidental; let i = $index) {
  <div class="h2">
    One-off invoice adjustment {{ i }}
  </div>
  <div class="card mb-3">
    <div class="card-body">
      <div class="row">
        <div class="col-md-7">
          <app-form-field label="Incidental type" [includeMargin]="false">
            <app-search [options]="incidentalTypes()"
                        [formControl]="incidental.controls.incidentalType"
                        [placeholder]="'Type to search'"
                        required
                        [inputFormatter]="incidentalFormatter">
            </app-search>
          </app-form-field>
        </div>

        @if (!isAmountHidden(incidental)) {
        <div class="col-md-2">
          <app-form-field
            label="Amount (&euro;)"
            [includeMargin]="false">

            <input
              type="number"
              class="form-control"
              [formControl]="incidental.controls.incidentalAmount"
              placeholder="Amount"
              required
            />

          </app-form-field>
        </div>
        }

        <div class="col-auto ms-auto">
          <button
            type="button"
            class="btn btn-link text-danger p-0"
            aria-label="Remove adjustment"
            (click)="removeIncidental(i)"
            [ngClass]="{
                              'disabled': !canEditIncidental(),
                              'enabled': canEditIncidental()
                              }">
            <i class="far fa-trash-alt"></i>
          </button>
        </div>

      </div>
      <div class="row mt-3">
        <div class="col-12">
          @if (incidental.controls.incidentalReason.value === null) {
            <button
              type="button"
              class="btn text-primary p-0 text-decoration-none"
              (click)="initRemark(incidental)">
              <i class="fa fa-pencil-alt"></i> Add a remark
            </button>
          }

          @if (incidental.controls.incidentalReason.value !== null) {
            <app-form-field label="Remarks">
                  <textarea
                    class="form-control"
                    [formControl]="incidental.controls.incidentalReason">
                  </textarea>
            </app-form-field>
          }
        </div>
      </div>
    </div>
  </div>
}

@if (isHarbourDuesAdvisor()) {
  <button
    type="button"
    class="btn btn-outline-primary mt-1 mb-2"
    (click)="addIncidental()">
    <i class="fa fa-plus"></i> Add adjustment
  </button>
}
